module.exports = __webpack_public_path__ + "static/media/after-welcome-left.e3ff7345.svg";